import styled from 'styled-components';

const WindcreekTab = styled.button`
  background: none;
  border: 0;
  color: ${props => props.theme.tabs.fontColor};
  opacity: 0.5;
  padding: 0.25em;
  flex: 1 0 auto;

  &:hover {
    opacity: 1;
  }

  &.active {
    background: none;
    opacity: 1;
  }

  &:after {
    content: '';
    height: 0.2em;
    display: block;
    width: 100%;
    border-radius: 0.2em;
    background: transparent;
    transition: background-color 150ms linear;
  }

  &.active:after {
    margin-top: 0.25rem;
    background: ${props => props.theme.tabs.indicatorColor};
  }

  &.active,
  &:hover,
  &:active,
  &:focus {
    opacity: 1;
    outline: none;
  }
`;

export default WindcreekTab;
